import { create } from "zustand";

export const useProjectStore = create((set) => ({
  projectId: null,
  projectName: null,
  buildingName: null,
  setProject: (projectId, projectName) => set({ projectId, projectName }),
  setBuildingName: (buildingName) => set({ buildingName }),
  clearProject: () => set({ projectId: null, projectName: null, buildingName: null }),
}));
